import { useEffect, useRef, useState } from 'react'
import {
  Box,
  Step,
  StepLabel,
  Stepper,
  Grid,
  Button,
  Stack,
  CircularProgress,
} from '@mui/material'

import logo from '../../../../assets/Altigen_logo_with_text.png'
import './steppers.css'
import nextbtn from '../../../../assets/icons/Next Button.svg'
import backbtn from '../../../../assets/icons/Back Button.svg'
import { useParams } from 'react-router-dom'
import CompanyDetails from './company-details/CompanyDetails'
import SaveAsIcon from '@mui/icons-material/SaveAs'
import {
  StepBackward,
  StepForward,
  setRevParent,
  setSIPDetails,
} from '../../../../store/slice/stepperSlice'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { CompanyDraft } from '../../../../api/post/postApi'
import { saveforlatercompanydraft } from '../../../../api/get/getApi'
import {
  formDetailsState,
  setcompanyName,
  setEmail,
  setCompanyDraftAll,
} from '../../../../store/slice/stepperSlice'
import Appearance from './appearance/Appearance'
import AccountDetails from './account-details/Accountdetails'
import ResellerBilling from './billing/Billinginfo'
import StepperPayment from './payment/Payment'
import BillingType from './billing/BillingType'
import { decodeToken, normalizeApiResponse } from '../../../../helpers/HelperFunctions'
import {
  COMPANY_LEVELS,
  CUSTOMER_SIP_STEPS,
  CUSTOMER_STEPS,
  DIRECT_CUSTOMER_SIP_STEPS,
  RESELLER_DIRECT_CUSTOMER_STEPS,
  SERVICE_PROVIDER_STEPS,
  SERVICES,
} from '../../../../helpers/Constants'
import { useToastContext } from '../../../../App'
import ConsentAndAcknowledgement from './consent-and-acknowledgement/ConsentAndAcknowledgement'
import SIPDetails from './sip-details/SIPDetails'
import { FlexBox } from '../../../../common/styles/styled-components/StyledContainers'

function SignupStepper(props) {
  const dispatch = useDispatch()
  const { toast } = useToastContext()
  const {
    appearance,
    accountDetail,
    billing,
    companyDetail,
    creditCard,
    bankAccount,
    billingType,
    step,
    isRevParent,
    altigenDirectCustomer,
    companyLevel,
    directCustomer,
    isAltigenBilling,
    paymentType,
    service,
    termsAndConditionBase64String,
    isTermsAndConditionsAccepted,
    sipDetails,
  } = useSelector(formDetailsState)
  useEffect(() => {
    if (localStorage.getItem('sd_cp.jwt:tkn')) {
      dispatch(
        setEmail(
          decodeToken(localStorage.getItem('sd_cp.jwt:tkn')).user_emailaddress
        )
      )
      dispatch(
        setcompanyName(
          decodeToken(localStorage.getItem('sd_cp.jwt:tkn')).company_name
        )
      )
    } else {
      dispatch(setEmail(localStorage.getItem('email')))
      dispatch(setcompanyName(localStorage.getItem('companyname')))
    }
  }, [])

  const navigate = useNavigate()
  let [steps, setSteps] = useState([])
  const [dynamicGridleft, setdynamicGridleft] = useState(5)
  const [dynamicGridright, setdynamicGridright] = useState(7)
  const [borderRightstyle, setborderRight] = useState(false)
  const [borderLeftStyle, setborderLeft] = useState(false)
  const [serviceCode, setServiceCode] = useState(0)
  const [height, setHeight] = useState(0)
  const ref = useRef(null)
  const companyid = localStorage.getItem('companyid')

  const { signUpId } = useParams()

  const nulltoemptyfromobj = async (arr) => {
    let newobj = {}
    const prom = Object.keys(arr).map((item) => {
      return (newobj = { ...newobj, [item]: arr[item] ?? '' })
    })
    const wait = await Promise.all([prom])
    return newobj
  }

  useEffect(() => {
    getcompanydraftbyId()
  }, [])

  useEffect(() => { }, [steps])

  const determineSteps = (result) => {
  if (result.companyLevel == COMPANY_LEVELS.serviceprovider) {
    return SERVICE_PROVIDER_STEPS
  }

  if (result.isAltigenBilling) {
    return RESELLER_DIRECT_CUSTOMER_STEPS
  }

  if (
    (result.companyLevel == COMPANY_LEVELS.reseller ||
      result.companyLevel == COMPANY_LEVELS.customer) &&
    !result.isAltigenBilling
  ) {
    return result.service === SERVICES.SipTrunking &&
      result.companyLevel == COMPANY_LEVELS.customer
      ? CUSTOMER_SIP_STEPS
      : CUSTOMER_STEPS
  }

  if (result.companyLevel == COMPANY_LEVELS.customer && !result.directCustomer) {
    return result.service === SERVICES.SipTrunking
      ? CUSTOMER_SIP_STEPS
      : CUSTOMER_STEPS
  }

  if (result.companyLevel == COMPANY_LEVELS.customer && result.directCustomer) {
    return result.service === SERVICES.SipTrunking
      ? DIRECT_CUSTOMER_SIP_STEPS
      : RESELLER_DIRECT_CUSTOMER_STEPS
  }

  return []
}


  const getcompanydraftbyId = async () => {
    const getcompanyid = localStorage.getItem('companyid')
    if(getcompanyid === null) return navigate('/login');
      if (!getcompanyid) return navigate('/login')

    const data = await saveforlatercompanydraft(getcompanyid)
  const result = data?.data?.result
  if (!result) return
setSteps(determineSteps(result))
 if (result.companyLevel == COMPANY_LEVELS.customer) {
    setServiceCode(result.service)
  }
const billingConcatObj = result.billingContact || result.billingAddress
    ? { ...result.billingContact, ...result.billingAddress }
    : null
dispatch(setSIPDetails(result.sipDetails))
dispatch(
    setCompanyDraftAll({
      accountDetail: await nulltoemptyfromobj(
        result.accountDetail ?? {
          email: localStorage.getItem('email'),
          firstName: '',
          lastName: '',
          phone: '',
          extNumber: '',
        }
      ),
      companyDetail: await nulltoemptyfromobj(
        result.companyDetail ?? {
          companyName: localStorage.getItem('companyname'),
          street: '',
          country: '',
          city: '',
          state: '',
          zip: '',
          phone: '',
          fax: '',
        }
      ),
      billing: await nulltoemptyfromobj(
        billingConcatObj ?? {
          email: '',
          firstName: '',
          lastName: '',
          mobile: '',
          fax: '',
          phone: '',
          phoneExtension: '',
          companyName: '',
          country: 'USA',
          state: '',
          city: '',
          zip: '',
          line1: '',
          line2: '',
        }
      ),
      creditCard: await nulltoemptyfromobj(
        result.paymentMethod?.creditCard ?? {
          firstName: '',
          lastName: '',
          cardNumber: '',
          expriationMonth: 0,
          expirationYear: 0,
          cvv: '',
        }
      ),
      bankAccount: await nulltoemptyfromobj(
        result.paymentMethod?.bankAccount ?? {
          accountName: '',
          accountNumber: '',
          routingNumber: '',
          accountType: '',
          bankName: '',
          checkNumber: '',
        }
      ),
      appearance: await nulltoemptyfromobj(result.appearance ?? { logoUrl: '' }),
      billingType: await nulltoemptyfromobj(result.billingType ?? { billingType: 1 }),
      step: result.step,
      isRevParent: result?.isRevParent,
      altigenDirectCustomer: result?.altigenDirectCustomer,
      companyLevel: result.companyLevel,
      isAltigenBilling: result.isAltigenBilling,
      directCustomer: result.directCustomer,
      paymentType: result.paymentMethod?.creditCard
        ? 'card'
        : result.paymentMethod?.bankAccount
        ? 'bank'
        : 'card',
    })
  )
}
   

  // const step5_4 = () => {
  //   if (companyLevel == COMPANY_LEVELS.serviceprovider || (companyLevel == COMPANY_LEVELS.reseller && isAltigenBilling)) {
  //     if (companyLevel == COMPANY_LEVELS.serviceprovider && billingType.billingType == 2) {
  //       dispatch(StepBackward(2))
  //     } else {
  //       dispatch(StepBackward())
  //     }
  //   } else if (companyLevel == COMPANY_LEVELS.customer && directCustomer === false) {
  //     dispatch(StepBackward(4))
  //   }
  //   else if (companyLevel == COMPANY_LEVELS.customer && isAltigenBilling) {
  //     if (companyLevel == COMPANY_LEVELS.serviceprovider && billingType.billingType == 2) {
  //       dispatch(StepBackward(2))
  //     } else {
  //       dispatch(StepBackward())
  //     }
  //   } else if ((companyLevel == COMPANY_LEVELS.reseller || companyLevel == COMPANY_LEVELS.customer) && !isAltigenBilling) {
  //     dispatch(StepBackward(3))
  //   }
  // }

  const [logourlhelpertext, setlogourlhelpertext] = useState('')

  const step5_6 = () => {
    if (appearance.logoUrl) {
      setlogourlhelpertext('')
      dispatch(StepForward())
    } else {
      setlogourlhelpertext('Upload your company logo')
    }
  }
  // const nextStep = () => {
  //   if (companyLevel == 2) {
  //     if (billingType.billingType == 2) {
  //       dispatch(StepForward(2))
  //     } else {
  //       dispatch(StepForward())
  //     }
  //   } else if ((companyLevel == COMPANY_LEVELS.reseller || companyLevel == COMPANY_LEVELS.customer) && isAltigenBilling) {
  //     dispatch(StepForward(2))
  //   } else if ((companyLevel == 3 || companyLevel == 4) && !isAltigenBilling) {
  //     dispatch(StepForward(3))
  //   }
  // }

  const [loading, setloading] = useState(false)

  const buildBillingData = (step, values, billing) => ({
  billingContact: step == 2
    ? {
        firstName: values.firstName,
        lastName: values.lastName,
        phone: values.phone,
        phoneExtension: values.phoneExtension,
        mobile: values.mobile,
        fax: values.fax,
        email: values.email,
      }
    : {
            firstName: billing.firstName,
            lastName: billing.lastName,
            phone: billing.phone,
            phoneExtension: billing.phoneExtension,
            mobile: billing.mobile,
            fax: billing.fax,
            email: billing.email,
          },
  billingAddress: step == 2
    ? {
        companyName: values.companyName,
        state: values.state,
        city: values.city,
        line1: String(values.line1),
        line2: values.line2,
        country: values.country,
        zip: values.zip?.toString(),
      }
    : {
            companyName: billing.companyName,
            state: billing.state,
            city: billing.city,
            line1: String(billing.line1),
            line2: billing.line2,
            country: billing.country,
            zip: billing.zip?.toString(),
          },
})

const buildPaymentData = (step, values, creditCard, bankAccount, paymentType) => ({
  creditCard:
    paymentType == 'card'
      ? step == 3 || step == 4
        ? { ...values, cardNumber: values?.cardNumber?.toString(), cvv: values?.cvv?.toString() }
        : { ...creditCard, cardNumber: creditCard?.cardNumber?.toString(), cvv: creditCard?.cvv?.toString() }
      : null,
  bankAccount: paymentType == 'bank' ? (step == 3 || step == 4 ? values : bankAccount) : null,
})
const companydraft = async (isSaveforlater, values) => {
  setloading(true)

  dispatch(setRevParent(billingType.billingType !== 1 ? false : true))

  const companyData = {
    companyId: companyid,
    step,
    accountDetail: step == 0 ? values : accountDetail,
    companyDetail: step == 1 ? values : companyDetail,
    appearance,
    isRevParent,
    altigenDirectCustomer,
    companyLevel,
    isAltigenBilling,
    billingType,
    isSubmitted: isTermsAndConditionsAccepted,
    isTermsAndConditionsAccepted,
    termsAndConditionsFileData: termsAndConditionBase64String,
    service,
    sipDetails,
    ...buildBillingData(step, values, billing),
    paymentMethod: buildPaymentData(step, values, creditCard, bankAccount, paymentType),
  }

  // ensure safe creditCard defaults
  if (companyData.paymentMethod?.creditCard) {
    companyData.paymentMethod.creditCard.expriationMonth ??= 0
    companyData.paymentMethod.creditCard.expirationYear ??= 0
  }

  try {
    await CompanyDraft(companyData, props?.config)

    setloading(false)
    if (isSaveforlater) {
      toast.showToast('Draft saved successfully')
    } else {
      localStorage.removeItem('email')
      toast.showToast('You have successfully completed signup')
      setTimeout(navfunction, 3000)
    }
  } catch (error) {
    setloading(false)
    const message = normalizeApiResponse(error)?.message
    if (!isSaveforlater && !companyData.appearance.logoUrl) {
      toast.showToast('File is not uploaded, Please press confirm button', 'error')
    } else {
      toast.showToast(message, 'error')
    }
  }
}

  const navfunction = () => {
    localStorage.clear()
    sessionStorage.clear()
    navigate('/login')
  }

  const getServiceProviderSteps = () => {
    switch (step) {
      case 0:
        return <AccountDetails companydraft={companydraft} />
      case 1:
        return (
          <>
            <CompanyDetails companydraft={companydraft} />
          </>
        )
      case 2:
        return (
          <>
            <ResellerBilling companydraft={companydraft} />
          </>
        )
      case 3:
        return (
          <>
            <BillingType config={props.config} />
            <Grid container columnSpacing={4}>
              <Grid item md={6} sm={6} xs={6}>
                <Stack
                  direction="row"
                  sx={{ pl: '24px', marginTop: '-12px' }}
                  spacing={2}
                >
                  <img
                    src={backbtn}
                    className="btn-hover-effect"
                    height="92px"
                    onClick={() => dispatch(StepBackward())}
                    alt="next button"
                  />
                  <img
                    src={nextbtn}
                    className="btn-hover-effect"
                    height="92px"
                    onClick={() => dispatch(StepForward())}
                    alt="next button"
                  />
                </Stack>
              </Grid>
              <Grid item md={6} sm={6} xs={6}>
                <Stack
                  style={{
                    justifyContent: 'right',
                    padding: ' 15px 3rem 0px 10px',
                  }}
                  direction="row"
                  spacing={2}
                >
                  <Button
                    variant="contained"
                    onClick={() => companydraft(true)}
                  >
                    <SaveAsIcon /> &nbsp; save for later
                  </Button>
                </Stack>
              </Grid>
            </Grid>
          </>
        )

      case 4:
        return (
          <>
            <StepperPayment companydraft={companydraft} />
          </>
        )
      case 5:
        return (
          <>
            <ConsentAndAcknowledgement />
          </>
        )
      default:
        return (
          <>
            <Appearance
              config={props.config}
              logohelpertext={logourlhelpertext}
            />
            <br/>
            <FlexBox gap={2} className='fullWidth' alignItems='center'>
              <img
                src={backbtn}
                className="btn-hover-effect"
                height="92px"
                onClick={() => dispatch(StepBackward())}
                alt="back button"
              />
              <Button
                fullWidth
                variant="contained"
                type="button"
                onClick={() => companydraft(false)}
              >
                Submit &emsp;
                {loading ? (
                  <CircularProgress sx={{ color: '#fff' }} size={20} />
                ) : null}
              </Button>
            </FlexBox>
          </>
        )
}
  }

const getResellerOrDirectCustomerSteps = () => {
  switch (step) {
    case 0:
      return (
        <>
          <AccountDetails companydraft={companydraft} />
        </>
      )
    case 1:
      return (
        <>
          <CompanyDetails companydraft={companydraft} />
        </>
      )
    case 2:
      return (
        <>
          <ResellerBilling companydraft={companydraft} />
        </>
      )

    case 3:
      return (
        <>
          <StepperPayment companydraft={companydraft} />
        </>
      )
    case 4:
      return (
        <>
          <ConsentAndAcknowledgement />
        </>
      )
    default:
      return (
        <>
          <Appearance
            config={props.config}
            logohelpertext={logourlhelpertext}
          />
           <FlexBox padding='0 20px' className='fullWidth' alignItems='center'>
              <img
                src={backbtn}
                className="btn-hover-effect"
                height="92px"
                onClick={() => dispatch(StepBackward())}
                alt="back button"
              />
              <Button
                fullWidth
                variant="contained"
                type="button"
                onClick={() => companydraft(false)}
              >
                Submit &emsp;
                {loading ? (
                  <CircularProgress sx={{ color: '#fff' }} size={20} />
                ) : null}
              </Button>
            </FlexBox>
        </>
      )
  }
}

const getCustomerSteps = () => {
  switch (step) {
    case 0:
      return (
        <>
          <AccountDetails companydraft={companydraft} />
        </>
      )
    case 1:
      return (
        <>
          <CompanyDetails companydraft={companydraft} />
        </>
      )
    case 2:
      return <ConsentAndAcknowledgement />
    default:
      return (
        <>
          <Appearance
            config={props.config}
            logohelpertext={logourlhelpertext}
          />
          <Box>
            <Grid container columnSpacing={4}>
              <Grid item md={6} sm={6} xs={6}>
                <Stack direction="row" sx={{ pl: '24px' }} spacing={2}>
                  <img
                    src={backbtn}
                    className="btn-hover-effect"
                    height="92px"
                    onClick={() => dispatch(StepBackward())}
                    alt="back button"
                  />
                </Stack>
              </Grid>
              <Grid item md={6}>
                <Stack
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  height="92px"
                  sx={{
                    justifyContent: 'right',
                    padding: ' 0px 3rem 0px 10px',
                    marginTop: '-15px',
                  }}
                  spacing={2}
                >
                  <Box sx={{ ml: '30px' }}>
                    <Button
                      style={{ marginTop: '28px' }}
                      variant="contained"
                      type="button"
                      onClick={() => companydraft(false)}
                    >
                      Submit &emsp;
                      {loading ? (
                        <CircularProgress sx={{ color: '#fff' }} size={20} />
                      ) : null}
                    </Button>
                  </Box>
                  {/*<Button variant='contained' onClick={() => companydraft(true)}><SaveAsIcon /> &nbsp; save for later</Button>*/}
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </>
      )
  }
}

const getCustomerSIPSteps = () => {
  if (companyLevel == COMPANY_LEVELS.customer && !directCustomer) {
    switch (step) {
      case 0:
        return <AccountDetails companydraft={companydraft} />
      case 1:
        return <CompanyDetails companydraft={companydraft} />
      case 2:
        return <SIPDetails />
      case 3:
        return <ConsentAndAcknowledgement />
      default:
        return (
          <>
            <Appearance
              config={props.config}
              logohelpertext={logourlhelpertext}
            />
            <Box>
              <Grid container columnSpacing={4}>
                <Grid item md={6} sm={6} xs={6}>
                  <Stack direction="row" sx={{ pl: '24px' }} spacing={2}>
                    <img
                      src={backbtn}
                      className="btn-hover-effect"
                      height="92px"
                      onClick={() => dispatch(StepBackward())}
                      alt="back button"
                    />
                  </Stack>
                </Grid>
                <Grid item md={6}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    height="92px"
                    sx={{
                      justifyContent: 'right',
                      padding: ' 0px 3rem 0px 10px',
                      marginTop: '-15px',
                    }}
                    spacing={2}
                  >
                    <Box sx={{ ml: '30px' }}>
                      <Button
                        style={{ marginTop: '28px' }}
                        variant="contained"
                        type="button"
                        onClick={() => companydraft(false)}
                      >
                        Submit &emsp;
                        {loading ? (
                          <CircularProgress
                            sx={{ color: '#fff' }}
                            size={20}
                          />
                        ) : null}
                      </Button>
                    </Box>
                    {/*<Button variant='contained' onClick={() => companydraft(true)}><SaveAsIcon /> &nbsp; save for later</Button>*/}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </>
        )
    }
  } else if (companyLevel == COMPANY_LEVELS.customer && directCustomer) {
    switch (step) {
      case 0:
        return (
          <>
            <AccountDetails companydraft={companydraft} />
          </>
        )
      case 1:
        return (
          <>
            <CompanyDetails companydraft={companydraft} />
          </>
        )
      case 2:
        return (
          <>
            <ResellerBilling companydraft={companydraft} />
          </>
        )

      case 3:
        return (
          <>
            <StepperPayment companydraft={companydraft} />
          </>
        )
      case 4:
        return (
          <>
            <SIPDetails />
          </>
        )
      case 5:
        return (
          <>
            <ConsentAndAcknowledgement />
          </>
        )
      default:
        return (
          <>
            <Appearance
              config={props.config}
              logohelpertext={logourlhelpertext}
            />
            <Box>
              <Grid container columnSpacing={4}>
                <Grid item md={6} sm={6} xs={6}>
                  <Stack direction="row" sx={{ pl: '24px' }} spacing={2}>
                    <img
                      src={backbtn}
                      className="btn-hover-effect"
                      height="92px"
                      onClick={() => dispatch(StepBackward())}
                      alt="back button"
                    />
                  </Stack>
                </Grid>
                <Grid item md={6}>
                  <Stack
                    direction="row"
                    alignItems="center"
                    justifyContent="center"
                    height="92px"
                    sx={{
                      justifyContent: 'right',
                      padding: ' 0px 3rem 0px 10px',
                      marginTop: '-15px',
                    }}
                    spacing={2}
                  >
                    <Box sx={{ ml: '30px' }}>
                      <Button
                        style={{ marginTop: '28px' }}
                        variant="contained"
                        type="button"
                        onClick={() => companydraft(false)}
                      >
                        Submit &emsp;
                        {loading ? (
                          <CircularProgress
                            sx={{ color: '#fff' }}
                            size={20}
                          />
                        ) : null}
                      </Button>
                    </Box>
                    {/*<Button variant='contained' onClick={() => companydraft(true)}><SaveAsIcon /> &nbsp; save for later</Button>*/}
                  </Stack>
                </Grid>
              </Grid>
            </Box>
          </>
        )
    }
  }
}

return (
  <>
    <Grid container ref={ref}>
      <Grid
        item
        md={dynamicGridleft}
        sm={dynamicGridleft}
        xs={4}
        sx={{
          paddingLeft: '65px',
          backgroundColor: '#F9FAFC',
          height: '100vh',
        }}
      >
        <Box
          sx={{
            marginTop: '50px',
          }}
        >
          <img
            src={logo}
            alt="logo"
            style={{ width: '400px', height: 'calc(100vh-101)' }}
          />
        </Box>
        <Box>
          <Stepper
            activeStep={step}
            style={{
              width: '100%',
              height: '100px',
              alignItems: 'flex-start',
            }}
            orientation="vertical"
          >
            {steps.map((label) => {
              const stepProps = {}
              const labelProps = {}

              return (
                <Step key={label} {...stepProps}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              )
            })}
          </Stepper>
        </Box>
      </Grid>
      <Grid item md={dynamicGridright} sm={dynamicGridright} xs={8}>
        <Box sx={{ marginTop: '50px', height: 'calc(100vh-101)' }}>
          {companyLevel == COMPANY_LEVELS.serviceprovider
            ? getServiceProviderSteps()
            : (companyLevel == COMPANY_LEVELS.reseller ||
              (companyLevel == COMPANY_LEVELS.customer &&
                directCustomer)) &&
              isAltigenBilling &&
              serviceCode !== SERVICES.SipTrunking
              ? getResellerOrDirectCustomerSteps()
              : companyLevel == COMPANY_LEVELS.customer &&
                !directCustomer &&
                serviceCode !== SERVICES.SipTrunking
                ? getCustomerSteps()
                : companyLevel == COMPANY_LEVELS.customer &&
                  serviceCode === SERVICES.SipTrunking
                  ? getCustomerSIPSteps()
                  :  serviceCode == 0 && getResellerOrDirectCustomerSteps() }

        </Box>
      </Grid>
    </Grid>
  </>
)
}

export default SignupStepper
